// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetSafetyAnchorPointsRequestModel from '../../model/get-safety-anchor-points-request-model';
import CreateSafetyAnchorPointRequestModel from '../../model/create-safety-anchor-point-request-model';
import UpdateSafetyAnchorPointRequestModel from '../../model/update-safety-anchor-point-request-model';
import MultiplySafetyAnchorPointRequestModel from '../../model/multiply-safety-anchor-point-request-model';
import GetSafetyAnchorPointRequestModel from '../../model/get-safety-anchor-point-request-model';
import DeleteSafetyAnchorPointRequestModel from '../../model/delete-safety-anchor-point-request-model';
import SafetyAnchorPointListPagingResultModel from '../../model/safety-anchor-point-list-paging-result-model';
import SafetyAnchorPointModel from '../../model/safety-anchor-point-model';

export default (service: Servicelayer) => ({
  /**  */
  async getSafetyAnchorPoints(request: GetSafetyAnchorPointsRequestModel, config?: RequestConfig) {
    const requestDTO = GetSafetyAnchorPointsRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-safety-anchor-points'] ?? 'siha/SiHaSafetyAnchorPoint';
    const response = await service.get<any>(endpointPath, {
      query: {
        sihaDocumentationId: requestDTO.sihaDocumentationId,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SafetyAnchorPointListPagingResultModel.toModel(dto));
  },
  /**  */
  async createSafetyAnchorPoint(request: CreateSafetyAnchorPointRequestModel, config?: RequestConfig) {
    const requestDTO = CreateSafetyAnchorPointRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-create-safety-anchor-point'] ?? 'siha/SiHaSafetyAnchorPoint';
    const response = await service.post<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        links: requestDTO.links,
        creatorId: requestDTO.creatorId,
        creatorName: requestDTO.creatorName,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modifierName: requestDTO.modifierName,
        modified: requestDTO.modified,
        siHaDocumentationId: requestDTO.siHaDocumentationId,
        safetyHookId: requestDTO.safetyHookId,
        name: requestDTO.name,
        screwLength: requestDTO.screwLength,
        remark: requestDTO.remark,
        isInstalledOnCounterBatten: requestDTO.isInstalledOnCounterBatten,
        installationRemark: requestDTO.installationRemark,
        installationDate: requestDTO.installationDate,
        isDocumentationCompleted: requestDTO.isDocumentationCompleted,
        previousSafetyAnchorPointId: requestDTO.previousSafetyAnchorPointId,
        nextSafetyAnchorPointId: requestDTO.nextSafetyAnchorPointId,
        documentationImage1ExternalId: requestDTO.documentationImage1ExternalId,
        documentationImage2ExternalId: requestDTO.documentationImage2ExternalId,
        documentationImage3ExternalId: requestDTO.documentationImage3ExternalId,
        documentationImage4ExternalId: requestDTO.documentationImage4ExternalId,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async updateSafetyAnchorPoint(request: UpdateSafetyAnchorPointRequestModel, config?: RequestConfig) {
    const requestDTO = UpdateSafetyAnchorPointRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-safety-anchor-point'] ?? 'siha/SiHaSafetyAnchorPoint';
    const response = await service.put<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        links: requestDTO.links,
        creatorId: requestDTO.creatorId,
        creatorName: requestDTO.creatorName,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modifierName: requestDTO.modifierName,
        modified: requestDTO.modified,
        siHaDocumentationId: requestDTO.siHaDocumentationId,
        safetyHookId: requestDTO.safetyHookId,
        name: requestDTO.name,
        screwLength: requestDTO.screwLength,
        remark: requestDTO.remark,
        isInstalledOnCounterBatten: requestDTO.isInstalledOnCounterBatten,
        installationRemark: requestDTO.installationRemark,
        installationDate: requestDTO.installationDate,
        isDocumentationCompleted: requestDTO.isDocumentationCompleted,
        previousSafetyAnchorPointId: requestDTO.previousSafetyAnchorPointId,
        nextSafetyAnchorPointId: requestDTO.nextSafetyAnchorPointId,
        documentationImage1ExternalId: requestDTO.documentationImage1ExternalId,
        documentationImage2ExternalId: requestDTO.documentationImage2ExternalId,
        documentationImage3ExternalId: requestDTO.documentationImage3ExternalId,
        documentationImage4ExternalId: requestDTO.documentationImage4ExternalId,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async multiplySafetyAnchorPoint(request: MultiplySafetyAnchorPointRequestModel, config?: RequestConfig) {
    const requestDTO = MultiplySafetyAnchorPointRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-multiply-safety-anchor-point'] ?? 'siha/SiHaSafetyAnchorPoint/{id}/Multiply/{count}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    endpointPath = endpointPath.replace(/\{count\}/g, `${requestDTO.count}`);
    const response = await service.post<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async getSafetyAnchorPoint(request: GetSafetyAnchorPointRequestModel, config?: RequestConfig) {
    const requestDTO = GetSafetyAnchorPointRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-safety-anchor-point'] ?? 'siha/SiHaSafetyAnchorPoint/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SafetyAnchorPointModel.toModel(dto));
  },
  /**  */
  async deleteSafetyAnchorPoint(request: DeleteSafetyAnchorPointRequestModel, config?: RequestConfig) {
    const requestDTO = DeleteSafetyAnchorPointRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-delete-safety-anchor-point'] ?? 'siha/SiHaSafetyAnchorPoint/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
  },
});
